export default "__VITE_ASSET__BZCWN3D$__"